import api from "../../api";

class ClientService {
  index(group_id) {
    return api.get(`client/service/${group_id}`);
  }
}

export default new ClientService();
